import * as Matter from 'matter-js';
import type { SceneDef } from './types';
import { createGround, createWalls, groundTopY } from './util';

export const collisions: SceneDef = {
  labelKey: 'scene.collisions',
  defaultPlaying: true,
  params: [
    { id: 'massA', labelKey: 'dim.massA', min: 0.5, max: 10, step: 0.5, value: 3 },
    { id: 'massB', labelKey: 'dim.massB', min: 0.5, max: 10, step: 0.5, value: 3 },
    // Lower velocity range so the collision pulse is visible on screen.
    { id: 'velocity', labelKey: 'dim.velocity', min: 0.5, max: 8, step: 0.5, value: 4 },
    { id: 'restitution', labelKey: 'dim.restitution', min: 0, max: 1, step: 0.05, value: 0.9 },
  ],
  build({ world, dims, bounds }) {
    const ground = createGround(bounds, 0);
    const walls = createWalls(bounds, { restitution: dims.restitution! });

    const radius = 30;
    const ballY = groundTopY(bounds) - radius;
    const ballA = Matter.Bodies.circle(bounds.width * 0.22, ballY, radius, {
      mass: dims.massA!,
      restitution: dims.restitution!,
      friction: 0,
      frictionAir: 0,
    });
    Matter.Body.setVelocity(ballA, { x: dims.velocity!, y: 0 });

    const ballB = Matter.Bodies.circle(bounds.width * 0.55, ballY, radius, {
      mass: dims.massB!,
      restitution: dims.restitution!,
      friction: 0,
      frictionAir: 0,
    });

    const bodies = [ground, ...walls, ballA, ballB];
    Matter.World.add(world, bodies);

    return {
      bodies,
      constraints: [],
      dispose() {
        Matter.World.remove(world, bodies);
      },
    };
  },
};
